__turbopack_context__.v({
  "className": "comic_neue_a4627ad7-module__7GJjIW__className",
});
